import { Icon } from "materia"
import { usePDFContext } from "../../providers"
import s from "./Navigation.module.scss"

export const Navigation = () => {
  const { currentPageNumber, numberOfPages, navigateToPage } = usePDFContext()

  return (
    <div className={s.navigation}>
      <button
        className={s.navigation__button}
        onClick={() => navigateToPage(currentPageNumber - 1)}
        disabled={currentPageNumber <= 1}
        title="Navigate to previous page"
      >
        <Icon icon="ArrowRight" size="large" rotate={180} />
      </button>

      <button
        className={s.navigation__button}
        onClick={() => navigateToPage(currentPageNumber + 1)}
        disabled={currentPageNumber >= numberOfPages}
        title="Navigate to next page"
      >
        <Icon icon="ArrowRight" size="large" />
      </button>
    </div>
  )
}
